import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { AssetServiceChecklist } from "./asset-service-checklist.entity";
import { ServiceStatusEnum } from "@gtpl/shared-models/common-models";

@Entity('asset_service')
export class AssetService {
    @PrimaryGeneratedColumn("increment", { name: 'asset_serve_id' })
    assetServeId: number;

    @Column("int", {
        nullable: false,
        name: "asset_id"
    })
    assetId: number;

    @Column("int", {
        nullable: false,
        name: "asset_name"
    })
    assetName: number;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "asset_category"
    })
    assetCategory: string;


    @Column("datetime", {
        nullable: true,
        name: "asset_service_date"
    })
    assetServiceDate: Date;

    @Column("datetime", {
        nullable: true,
        name: "act_asset_service_date"
    })
    actAssetServiceDate: Date;

    @Column("boolean", {
        nullable: false,
        name: "is_active",
        default: true
    })
    isActive: boolean | null;


    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "service_provider"
    })
    serviceProvider: string;

    @Column("varchar", {
        nullable: true,
        length: 1000,
        name: "service_name"
    })
    serviceName: string;

    @Column("enum", {
        nullable: true,
        name: "status",
        enum: ServiceStatusEnum
    })
    status: ServiceStatusEnum;

    @Column({
        name: "remarks",
        type:"text"
    })
    remarks:string

    @Column({
        name: "service_owner",
        type:"text"
    })
    serviceOwner:string

    @Column({
        name: "phone_number",
        type:"text"
    })
    phoneNumber:string

    @Column({
        name: "start_date",
        type: "datetime"
    })
    startDate: Date;

    @Column({
        name: "completed_date",
        type: "datetime"
    })
    completedDate: Date;

    @Column("varchar", {
        nullable: false,
        name: "service_type",
        length: 50

    })
    serviceType: string | null;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(() => AssetServiceChecklist, assetChecklist => assetChecklist.assetService, { cascade: true })
    assetServiceChecklist: AssetServiceChecklist[];
}